import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appDateFormatDirective]'
})
export class DateFormatDirectiveDirective {
  oldValue:any; 
  @Input() formCtrl:any;
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const inputValue = input.value;
    const cursorPosition = input.selectionStart;

    // Remove non-digit characters from the input value
    const numericValue = inputValue.replace(/\D/g, '');

    // Format the numeric value as DD/MM/YYYY
    const formattedValue = this.formatDate(numericValue);

    // Set the formatted value back to the input field
    input.value = formattedValue;
   

    const isLess = this.oldValue?.length > formattedValue.length;
    
    
    // Calculate the cursor position based on the original and formatted values
    const newPosition = (isLess? 0 :cursorPosition!) + this.calculateCursorPositionChange(this.oldValue || inputValue, formattedValue);
    this.oldValue = formattedValue;
    this.formCtrl?.setValue(formattedValue);
    input.setSelectionRange(newPosition, newPosition);
  }

  private calculateCursorPositionChange(originalValue: string, formattedValue: string): number {
    let newPosition = 0;
    for (let i = 0; i < originalValue.length && i < formattedValue.length; i++) {
      if (originalValue[i] === formattedValue[i]) {
        newPosition++;
      } else {
        break;
      }
    }
    return newPosition;
  }


  private formatDate(value: string): string {
    const month = value.slice(0, 2);
    const day = value.slice(2, 4);
    const year = value.slice(4, 8);

    // Concatenate the formatted parts with slashes
    return `${month}${day? '/':''}${day}${year?'/':''}${year}`;
  }

}
